import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('PrincipalCheckConfig', PrincipalCheckConfigData);

    function PrincipalCheckConfigData() {
        function PrincipalCheckConfig(principalCheckConfigData) {
            this.allControlsResult = principalCheckConfigData.allControlsResult;
        }

        return PrincipalCheckConfig;
    }
})();
